/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramTransactionsUserControllerGetActivePaymentSystemsQueryResponse,
  TelegramTransactionsUserControllerGetActivePaymentSystems401,
} from '../types/TelegramTransactionsUserControllerGetActivePaymentSystems.ts';

function getTelegramTransactionsUserGetActivePaymentSystemsUrl() {
  const res = { method: 'GET', url: `/api/user/telegram/transactions/active-payment-systems` as const };
  return res;
}

/**
 * {@link /api/user/telegram/transactions/active-payment-systems}
 */
export async function telegramTransactionsUserGetActivePaymentSystems(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramTransactionsUserControllerGetActivePaymentSystemsQueryResponse,
    ResponseErrorConfig<TelegramTransactionsUserControllerGetActivePaymentSystems401>,
    unknown
  >({ method: 'GET', url: getTelegramTransactionsUserGetActivePaymentSystemsUrl().url.toString(), ...requestConfig });
  return res.data;
}
